import { defineStore } from 'pinia'
import { toRaw } from "vue";
import { AuthState } from './types'
import { 
  AUTH_TOKEN, 
  AUTH_REFRESH, 
  AUTH_USER, 
  USER_MENU,
  OPTIONAL_SETTING,
  MAP_STATE,
  TABLE_STATE,
  DATETIME_STATE,
  CHART_STATE,
  COOKIE,
  INFO_BANNER
 } from 'core/constants'


export const useState = defineStore({
  id: 'auth.state',
  state: (): AuthState => {
    return {
      isAuthenticated: !!localStorage.getItem(AUTH_TOKEN),
      user: JSON.parse(localStorage.getItem(AUTH_USER) || 'null'),
      access: JSON.parse(localStorage.getItem(AUTH_TOKEN) || 'null'),
      refresh: JSON.parse(localStorage.getItem(AUTH_REFRESH) || 'null'),
      menu: JSON.parse(localStorage.getItem(USER_MENU) || 'null'),
      setting: JSON.parse(localStorage.getItem(OPTIONAL_SETTING) || 'null'),
      map: JSON.parse(localStorage.getItem(MAP_STATE) || 'null'),
      table: JSON.parse(localStorage.getItem(TABLE_STATE) || 'null'),
      datetime: JSON.parse(localStorage.getItem(DATETIME_STATE) || 'null'),
      chart: JSON.parse(localStorage.getItem(CHART_STATE) || 'null'),
      cookie: JSON.parse(localStorage.getItem(COOKIE) || 'null'),
      info_banner: JSON.parse(localStorage.getItem(INFO_BANNER) || 'null'),
    }
  },
  actions: {
    setUser(newUser: any) {
      this.user = newUser
      localStorage.setItem(AUTH_USER, JSON.stringify(this.user))
    },
    setTokens(newAccess: string, newRefresh: string) {
      this.access = newAccess
      this.refresh = newRefresh
      localStorage.setItem(AUTH_TOKEN, JSON.stringify(this.access))
      localStorage.setItem(AUTH_REFRESH, JSON.stringify(this.refresh))
    },
    setMenu(newMenu: any) {
      this.menu = newMenu
      localStorage.setItem(USER_MENU, JSON.stringify(this.menu))
    },
    removeUser(){
      this.user = null
      localStorage.removeItem(AUTH_USER)
    },
    removeTokens(){
      this.access = ""
      this.refresh = ""
      localStorage.removeItem(AUTH_TOKEN)
      localStorage.removeItem(AUTH_REFRESH)
    },
    removeMenu(){
      this.menu = null
      localStorage.removeItem(USER_MENU)
    },
    //setSetting(newSetting: any) {
    //  this.setting = newSetting
    //  localStorage.setItem(OPTIONAL_SETTING, JSON.stringify(toRaw(this.setting), removeCircularReferences()))
    //},
    setSetting(newSetting: any) {
      this.setting = {
        ...this.setting,
        setting: {
          ...this.setting?.setting,
          ...newSetting.setting
        }
      }
    
      localStorage.setItem(
        OPTIONAL_SETTING,
        JSON.stringify(toRaw(this.setting), removeCircularReferences())
      )
    },
    removeSetting(){
      this.setting = null
      localStorage.removeItem(OPTIONAL_SETTING)
    },
    setMap(newMap: any) {
      this.map = newMap
      localStorage.setItem(MAP_STATE, JSON.stringify(toRaw(this.map), removeCircularReferences()))
    },
    removeMap(){
      this.map = null
      localStorage.removeItem(MAP_STATE)
    },
    setTable(newTable: any) {
      this.table = newTable
      localStorage.setItem(TABLE_STATE, JSON.stringify(toRaw(this.table), removeCircularReferences()))
    },
    removeTable(){
      this.table = null
      localStorage.removeItem(TABLE_STATE)
    },
    setDatetime(newDatetime: any) {
      this.datetime = newDatetime
      localStorage.setItem(DATETIME_STATE, JSON.stringify(toRaw(this.datetime), removeCircularReferences()))
    },
    removeDatetime(){
      this.datetime = null
      localStorage.removeItem(DATETIME_STATE)
    },
    setChart(newChart: any) {
      this.chart = newChart
      localStorage.setItem(CHART_STATE, JSON.stringify(toRaw(this.chart), removeCircularReferences()))
    },
    removeChart(){
      this.chart = null
      localStorage.removeItem(CHART_STATE)
    },
    setCookie(newCookie: any) {
      this.cookie = newCookie
      localStorage.setItem(COOKIE, JSON.stringify(this.cookie))
    },
    removeCookie(){
      this.cookie = false
      localStorage.removeItem(COOKIE)
    },
    setInfoBanner(newInfoBanner: any) {
      this.info_banner = newInfoBanner
      localStorage.setItem(INFO_BANNER, JSON.stringify(this.info_banner))
    },
  },
})
function removeCircularReferences(): ((this: any, key: string, value: any) => any) | undefined {
  const seen = new WeakSet();
    return (key:any, value:any) => {
      if (typeof value === "object" && value !== null) {
        if (seen.has(value)) return; // Evita riferimenti circolari
        seen.add(value);
      }
      return value;
    };
}

